import { ImageNumber } from './common/ImageNumber';
import { SimpleButton } from './common/SimpleButton';
import { GameQuizResources } from './GameQuizResources';
import { GameView } from "./common/GameView";
import { CustomText } from "./common/CustomText";
import { threadId } from 'worker_threads';
import { GameQuizMain } from './GameQuizMain';
import { SoundPlayer } from './GameCommon';

export class GameQuizGameView extends GameView {
    protected backButton: SimpleButton;
    protected updateRankingButton: SimpleButton;
    static eventTagBack: string = "game_back";
    protected resources: GameQuizResources;
    constructor(width: number, height: number, resources: GameQuizResources) {
        super(width, height);
        this.resources = resources;
    }

    private eventlistenerId: any;

    private Mask: createjs.Shape;
    
    private GameArea: createjs.Container;
    private text_score_value: ImageNumber;

    private countdownContainer: createjs.Container;
    private CountdownMask: createjs.Shape;

    private QuestionArea: createjs.Container;
    private QuizQuestionWindow: Array<QuestionObject>;

    private ResultContainer: createjs.Container;    
    private ResultMask: createjs.Shape;
    private ResultScoreArea: createjs.Container;    

    protected retryButton: createjs.Sprite;
    protected returnButton: createjs.Sprite;

    protected BackGroundBase: createjs.Sprite;
    protected BackGroundPapa: createjs.Sprite;
    protected BackGroundMama: createjs.Sprite;

    protected BackGroundResult: createjs.Sprite;

    private timebar_normal: createjs.Bitmap;
    private timebar_challenge: createjs.Bitmap;
    private MaxTime: number = 10 * 1000;    // ゲーム時間

    private GamePoseFlag:boolean = false;    

    private GAME_SCORE_OK:number = 1;
    private GAME_SCORE_NG:number = -1;

    private Window_answer: createjs.Sprite;
    private Window_question: createjs.Sprite;
    private Window_quizImage: createjs.Sprite;
    private Window_quizImageArea: createjs.Sprite;

    private TimeBarContainer: createjs.Container;   
    private Timegauge_bg: createjs.Sprite;
    private Timegauge_bar: createjs.Sprite;

    private timebar: TimeBar;

    private CountDown3: createjs.Sprite;
    private CountDown2: createjs.Sprite;
    private CountDown1: createjs.Sprite;
    private CountDownStart: createjs.Sprite;

    private QuiestionRight: createjs.Sprite;
    private QuiestionWrong: createjs.Sprite;

    protected QuestionWindowXY:Array<QuestionWindowXY> = [
        {x:12, y:650+(110*0), img:"get_game_window_answer_a"},
        {x:12, y:650+(110*1), img:"get_game_window_answer_b"},
        {x:12, y:650+(110*2), img:"get_game_window_answer_c"},
        {x:12, y:650+(110*3), img:"get_game_window_answer_d"},
    ];

    protected QuestionUser:Array<QuestionUser> = [
        {text:"お答えください！", bg:"get_background", img:""},
        {text:"パパが\nお答えください！", bg:"get_background_p", img:"get_game_questionPyaker_papa"},
        {text:"ママが\nお答えください！", bg:"get_background_m", img:"get_game_questionPyaker_mama"},
    ];
    
    protected ResultRankTable_once = [
        {score:12, text:"完璧です！\nあなたは、保活の神です！"},
        {score:9, text:"ハイレベル！\nあなたは、保活マスターです！"},
        {score:6, text:"イイ感じ！\nあなたは、保活上級者です！"},
        {score:5, text:"もう少し！\nあなたは、保活中級者です！"},
        {score:3, text:"頑張って！\nあなたは、保活初心者です！"},
        {score:0, text:"今からです！\nあなたは、保活超初心者です！"},
    ];

    protected ResultRankTable_family = [
        {score:6, text:"完璧です！\nあなたは、保活の神です！"},
        {score:5, text:"ハイレベル！\nあなたは、保活マスターです！"},
        {score:4, text:"イイ感じ！\nあなたは、保活上級者です！"},
        {score:3, text:"もう少し！\nあなたは、保活中級者です！"},
        {score:2, text:"頑張って！\nあなたは、保活初心者です！"},
        {score:0, text:"今からです！\nあなたは、保活超初心者です！"},
    ];
    private score: number;
    private score_papa: number;
    private score_mama: number;
    private timerCount: number;
    private timerStart: Date;
    private PlayGameFlag: boolean;
    
    private thisCorrect:number;

    private resultScores = [];
    private RsultScoreObject = {};
    private ResultText_once: CustomText;
    private ResultRankText_once: CustomText;

    private ResultText_family_a: CustomText;
    private ResultRankText_family_a: CustomText;
    private ResultText_family_b: CustomText;
    private ResultRankText_family_b: CustomText;   
    
    private questAll: number;
    private questNum: number;

    private answerUser: number;
    private AnswerUserPapa:number = 1;
    private AnswerUserMama:number = 2;
    
    private NavigateTextLeft: CustomText;
    private NavigateTextRight: CustomText;
    private questionText: CustomText;
    
    private QuestionTable;
    private QuestionTableP = [];
    private QuestionTableM = [];
    private QuestionTableO = [];

    private Sound:SoundPlayer;

    async initClass(): Promise<void> {

        
        // ゲーム用
        this.GameArea = new createjs.Container();
        this.GameArea.setBounds(0, 0, this.width, this.height);
        this.GameArea.alpha = 1;
        this.addChild(this.GameArea);

        //背景
        this.BackGroundBase = this.resources.get_background();
        this.GameArea.addChild(this.BackGroundBase);
        this.BackGroundPapa = this.resources.get_background_p();
        this.GameArea.addChild(this.BackGroundPapa);
        this.BackGroundMama = this.resources.get_background_m();
        this.GameArea.addChild(this.BackGroundMama);

        /*this.Window_quizImageArea = new createjs.Shape();
        this.Window_quizImageArea.graphics.beginFill("#fff").drawRect(0, 0, 740, 350);
        this.Window_quizImageArea.x = 5;
        this.Window_quizImageArea.y = 5;
        this.Window_quizImageArea.alpha = 0.25;
        this.GameArea.addChild(this.Window_quizImageArea);
        */
        this.Window_quizImageArea = this.resources.get_game_window_selection();
        this.Window_quizImageArea.x = 0;
        this.Window_quizImageArea.y = 0;
        this.Window_quizImageArea.scaleX = 2;
        this.Window_quizImageArea.scaleY = 3;
        this.Window_quizImageArea.visible = false;
        this.GameArea.addChild(this.Window_quizImageArea);
        
        //
        this.Window_question = this.resources.get_game_window_question();
        this.Window_question.x = 12;
        this.Window_question.y = 360;
        this.Window_question.visible = false;
        this.GameArea.addChild(this.Window_question);

        //
        this.Window_answer = this.resources.get_game_window_answer();
        //this.GameArea.addChild(this.Window_answer);

        // タイマー用
        this.TimeBarContainer = new createjs.Container();
        this.TimeBarContainer.setBounds(0, 0, this.width, this.height);
        this.TimeBarContainer.alpha = 1;
        this.GameArea.addChild(this.TimeBarContainer);

        //
        this.Timegauge_bg = this.resources.get_game_timebar_bg();
        this.Timegauge_bg.x = 135/2;
        this.Timegauge_bg.y = this.Window_question.y+170;
        //this.GameArea.addChild(this.Timegauge_bg);

        //
        this.Timegauge_bar = this.resources.get_game_timebar();
        this.Timegauge_bar.x = this.Timegauge_bg.x+64;
        this.Timegauge_bar.y = this.Timegauge_bg.y+34;
        
        //this.GameArea.addChild(this.Timegauge_bar);
        //this.GameArea.addChild(this.Timegauge_bg);

        this.timebar = new TimeBar();
        
        //text: string = '', fontSize: number = 12, color: string = '#000', textAlign: string = 'left', textBaseline: string = 'top', bBold: boolean = false, bMultiline:boolean = false, maxWidth?:number, lineHeight?:number
        this.questionText = new CustomText();
        this.questionText.setFont(40, true);
        this.questionText.lineHeight = 40;
        this.questionText.color = '#000';
        this.questionText.setMaxWidth(40*17);

        this.questionText.x = this.Window_question.x + 18;
        this.questionText.y = this.Window_question.y + 10;
        this.GameArea.addChild(this.questionText);

        this.NavigateTextLeft = new CustomText();
        this.NavigateTextLeft.setFont(30, true);
        this.NavigateTextLeft.color = '#000';
        this.NavigateTextLeft.setMaxWidth(40*5);

        this.NavigateTextLeft.x = this.Window_question.x + 30;
        this.NavigateTextLeft.y = this.Window_question.y - 40;
        this.GameArea.addChild(this.NavigateTextLeft);
        
        this.NavigateTextRight = new CustomText();
        this.NavigateTextRight.setFont(30, false);
        this.NavigateTextRight.color = '#000';
        this.NavigateTextRight.setMaxWidth(40*17);

        this.NavigateTextRight.x = this.Window_question.x + 600;
        this.NavigateTextRight.y = this.Window_question.y - 40;
        this.GameArea.addChild(this.NavigateTextRight);

        this.timerCount = 0;
        //this.timerStart = 0;
        this.PlayGameFlag = false;

        // カウント用マスク
        this.countdownContainer = new createjs.Container();
        this.countdownContainer.setBounds(0, 0, this.width, this.height);
        this.countdownContainer.alpha = 1;
        this.addChild(this.countdownContainer);
        // ゲーム中のみ停止、あとは下レイヤーのクリック防止
        this.countdownContainer.addEventListener('click', () => {
            if (this.PlayGameFlag) {
                this.stopgGame();
            }
        });

        this.CountdownMask = new createjs.Shape();
        this.CountdownMask.graphics.beginFill("#000").drawRect(0, 0, this.width, this.height);
        this.CountdownMask.alpha = 0.5;
        this.countdownContainer.addChild(this.CountdownMask);

        //
        this.CountDown3 = this.resources.get_game_countdown3();
        this.CountDown3.x = (this.width/2)-(200/2);
        this.CountDown3.y = (this.height/2)-(this.resources.get_game_countdown3().getBounds().height/2)-60;
        this.CountDown3.visible = false;
        this.countdownContainer.addChild(this.CountDown3);

        this.CountDown2 = this.resources.get_game_countdown2();
        this.CountDown2.x = (this.width/2)-(200/2);
        this.CountDown2.y = (this.height/2)-(this.resources.get_game_countdown2().getBounds().height/2)-60;
        this.CountDown2.visible = false;
        this.countdownContainer.addChild(this.CountDown2);

        this.CountDown1 = this.resources.get_game_countdown1();
        this.CountDown1.x = (this.width/2)-(200/2);
        this.CountDown1.y = (this.height/2)-(this.resources.get_game_countdown1().getBounds().height/2)-60;
        this.CountDown1.visible = false;
        this.countdownContainer.addChild(this.CountDown1);

        this.CountDownStart = this.resources.get_game_time_start();
        //this.CountDownStart.x = (this.width/2);
        this.CountDownStart.y = (this.height/2)-(this.resources.get_game_time_start().getBounds().height/2)-60;
        this.CountDownStart.visible = false;
        this.countdownContainer.addChild(this.CountDownStart);

        // 問題用
        this.QuestionArea = new createjs.Container();
        this.QuestionArea.setBounds(0, 0, this.width, this.height);
        this.QuestionArea.alpha = 1;
        this.countdownContainer.addChild(this.QuestionArea);

        // 結果画面
        this.ResultContainer = new createjs.Container();
        this.ResultContainer.setBounds(0, 0, this.width, this.height);
        this.ResultContainer.alpha = 1;
        this.ResultContainer.visible = false;
        this.addChild(this.ResultContainer);

        this.BackGroundResult = this.resources.get_background();
        this.ResultContainer.addChild(this.BackGroundResult);

        this.ResultMask = new createjs.Shape();
        this.ResultMask.graphics.beginFill("#000").drawRect(0, 0, this.width, this.height);
        this.ResultMask.alpha = 0.1;
        this.ResultContainer.addChild(this.ResultMask);

        this.ResultScoreArea = new createjs.Container();
        this.ResultScoreArea.setBounds(0, 0, this.width, this.height);
        this.ResultScoreArea.visible = false;
        this.ResultContainer.addChild(this.ResultScoreArea);

        // 1人用
        this.ResultText_once = new CustomText();
        this.ResultText_once.setFont(60, true);
        this.ResultText_once.color = '#FFF';
        this.ResultText_once.textAlign = "center";
        this.ResultText_once.shadow = new createjs.Shadow('#000', 4, 4, 0);
        this.ResultText_once.x = this.width/2;
        this.ResultText_once.y = this.Window_question.y-96;
        this.ResultContainer.addChild(this.ResultText_once);

        this.ResultRankText_once = new CustomText();
        this.ResultRankText_once.setFont(48, true);
        this.ResultRankText_once.lineHeight = 60;
        this.ResultRankText_once.color = '#FFF';
        this.ResultRankText_once.textAlign = "center";
        this.ResultRankText_once.shadow = new createjs.Shadow('#000', 6, 6, 0);
        this.ResultRankText_once.x = this.width/2;
        this.ResultRankText_once.y = this.Window_question.y+24;
        this.ResultContainer.addChild(this.ResultRankText_once);

        // 2人用
        this.ResultText_family_a = new CustomText();
        this.ResultText_family_a.setFont(48, true);
        this.ResultText_family_a.color = '#FFF';
        this.ResultText_family_a.textAlign = "left";
        this.ResultText_family_a.shadow = new createjs.Shadow('#000', 4, 4, 0);
        this.ResultText_family_a.x = this.width/2-60;
        this.ResultText_family_a.y = 100;
        this.ResultContainer.addChild(this.ResultText_family_a);

        this.ResultRankText_family_a = new CustomText();
        this.ResultRankText_family_a.setFont(30, true);
        this.ResultRankText_family_a.lineHeight = 36;
        this.ResultRankText_family_a.color = '#FFF';
        this.ResultRankText_family_a.textAlign = "left";
        this.ResultRankText_family_a.shadow = new createjs.Shadow('#000', 2, 2, 0);
        this.ResultRankText_family_a.x = this.ResultText_family_a.x;
        this.ResultRankText_family_a.y = this.ResultText_family_a.y+60;
        this.ResultContainer.addChild(this.ResultRankText_family_a);

        this.ResultText_family_b = new CustomText();
        this.ResultText_family_b.setFont(48, true);
        this.ResultText_family_b.color = '#FFF';
        this.ResultText_family_b.textAlign = "left";
        this.ResultText_family_b.shadow = new createjs.Shadow('#000', 4, 4, 0);
        this.ResultText_family_b.x = this.width/2-60;
        this.ResultText_family_b.y = 500;
        this.ResultContainer.addChild(this.ResultText_family_b);

        this.ResultRankText_family_b = new CustomText();
        this.ResultRankText_family_b.setFont(30, true);
        this.ResultRankText_family_b.lineHeight = 36;
        this.ResultRankText_family_b.color = '#FFF';
        this.ResultRankText_family_b.textAlign = "left";
        this.ResultRankText_family_b.shadow = new createjs.Shadow('#000', 2, 2, 0);
        this.ResultRankText_family_b.x = this.ResultText_family_b.x;
        this.ResultRankText_family_b.y = this.ResultText_family_b.y+60;
        this.ResultContainer.addChild(this.ResultRankText_family_b);

        this.retryButton = this.resources.get_game_result_btn_retry();
        this.retryButton.x = (this.width/2) - (this.resources.get_game_result_btn_retry().getBounds().width/2);
        this.retryButton.y = 840;
        this.retryButton.visible = false;
        this.ResultContainer.addChild(this.retryButton);
        
        // ボタン
        this.retryButton.addEventListener('click', () => {
            this.dispatchEvent(new createjs.Event(GameQuizGameView.eventTagBack, true, false));
        });    

        this.returnButton = this.resources.get_game_result_btn_return();
        this.returnButton.x = (this.width/2) - (this.resources.get_game_result_btn_return().getBounds().width/2);
        this.returnButton.y = 980;
        this.returnButton.visible = false;
        this.ResultContainer.addChild(this.returnButton);

        // ボタン
        this.returnButton.addEventListener('click', () => {
            //this.dispatchEvent(new createjs.Event(GameQuizGameView.eventTagBack, true, false));
            window.location.href = "https://gamepark.site/login/hokatsuassist/";
        });    

        //
        this.Sound = new SoundPlayer;
        this.Sound.init();

    }

    protected async createScenes(): Promise<void> {

    }

    async initScenes(): Promise<void> {
        //console.log("initScenes");

        this.GameArea.visible = true;
        this.ResultContainer.visible = false;

        this.BackGroundBase.visible = true;
        this.BackGroundPapa.visible = false;
        this.BackGroundMama.visible = false;

        this.initGame();

        // this.backButton.enable();
    }


    /**
     * ゲーム開始前の初期化
     */
    initGame() {

        //console.log("initGame");
        //console.log(GameQuizMain.selectGame);

        this.questAll = 12;
        this.questNum = 0;
        this.score = 0;
        this.score_papa = 0;
        this.score_mama = 0;

        this.NavigateTextLeft.text = "";
        this.NavigateTextRight.text  = "";
        this.questionText.text  = "";

        //this.RsultScore = [0,0,0,0,0,0,0,0,0,0];
        for(let i=0; i<this.questAll; i++) {
            this.resultScores[i] = new ResultScore();
            this.resultScores[i].score = this.GAME_SCORE_NG;
            if (GameQuizMain.selectGame == GameQuizMain.SELECT_GAMETYPE_ONCE) {
                this.resultScores[i].x = 75+( Math.floor(i%6)*100);
                this.resultScores[i].y = 550+( Math.floor(i/6)*100);
            } else {
                this.resultScores[i].x = 75+( Math.floor((i/2)%6)*100);
                this.resultScores[i].y = 300+( Math.floor((i%2))*400);;
            }
            this.resultScores[i].img = null;
            this.resultScores[i].user = 0;
        }
        //console.log(this.resultScores);
        //DEBUG 
        /*this.questNum = 11;
        for(let i=0; i<this.questAll; i++) { 
            this.resultScores[i].score = this.GAME_SCORE_OK;
            this.resultScores[i].user = this.checkuser(i);
        }*/
       
        // シャッフル
        this.QuestionTable = this.resources.QuestionLIst["00"];
        
        if (!GameQuizMain.isDebug) {
            let tmp = this.QuestionTable.map(
                        function(a){return {weight:Math.random(), value:a}})
                        .sort(function(a, b){return a.weight - b.weight})
                        .map(function(a){return a.value}
            );
            this.QuestionTable = tmp;
        } else {
            this.questAll = this.QuestionTable.length;
            this.questNum = 0;
        }
        //console.log( this.QuestionTable );

        // モード別に振り分け
        this.QuestionTableO = [];
        this.QuestionTableP = [];
        this.QuestionTableM = [];
        let k=0;
        for(let j=0; j<Object.keys(this.QuestionTable).length; j++) {
            if (GameQuizMain.selectGame == GameQuizMain.SELECT_GAMETYPE_ONCE) {
                if (this.QuestionTable[j][5] == 0) {
                    this.QuestionTableO.push(this.QuestionTable[j]);
                }
            } else {
                if (j % 2) {
                    if (this.QuestionTable[j][5] == 0 || this.QuestionTable[j][5] == 2){
                        this.QuestionTableM.push(this.QuestionTable[j]);
                    }
                } else {
                    if (this.QuestionTable[j][5] == 0 || this.QuestionTable[j][5] == 1){
                        this.QuestionTableP.push(this.QuestionTable[j]);
                    }
                }
            }
        }

        //console.log( this.QuestionTableO );
        //console.log( this.QuestionTableM );
        //console.log( this.QuestionTableP );

        this.TimeBarContainer.removeAllChildren();

        this.timebar = new TimeBar();
        this.timebar.x = this.Timegauge_bg.x; //;
        this.timebar.y = this.Timegauge_bg.y; 
        this.timebar.image = this.resources.get_game_timebar_bg();
        this.timebar.bmp = this.resources.get_game_timebar_bg_bmp();
        //this.timebar.image.x = this.Timegauge_bg.x+64;
        //this.timebar.image.y = this.Timegauge_bg.y+34;
        this.timebar.image.scaleX = 1;
        this.timebar.setTimer( (10*1000), this.timebar.MINING);
        
        this.TimeBarContainer.addChild(this.timebar.bmp);
        this.TimeBarContainer.addChild(this.timebar.image);

        // カウント開始
        this.countdown();
    }

    /*
    * 開始時演出
    */
    countdown() {

        //console.log("countdown");        
        this.CountDown3.visible = false;
        this.CountdownMask.visible = true;
        this.CountdownMask.alpha = 0;
        
        this.timebar.image.scaleX = 1;
        this.timebar.setTimer( (10*1000), this.timebar.MINING);
        this.timebar.visible(false);

        this.Window_question.visible = false;
        this.Window_quizImageArea.visible = false;

        createjs.Tween.get(this.CountdownMask)
        .to({ alpha: 0.0 }, 250).call(() => {
            this.CountDown3.visible = true;
            this.Sound.playSE( "SE_START_COUNT" );
        })
        .wait(500)
        .call(() => {
            this.CountDown2.visible = true;
            this.CountDown3.visible = false;

            this.Sound.playSE( "SE_START_COUNT" );
        })
        .wait(500)
        .call(() => {
            this.CountDown1.visible = true;
            this.CountDown2.visible = false;

            this.Sound.playSE( "SE_START_COUNT" );
        })
        .wait(500)
        .call(() => {
            this.CountDownStart.visible = true;
            this.CountdownMask.visible = false;
            this.CountDown1.visible = false;

            this.Sound.playSE( "SE_START_DOWN" );
        })
        .wait(1000)
        .call(() => {

            this.Window_question.visible = true;
            this.Window_quizImageArea.visible = true;
            this.CountDownStart.visible = false;
            this.playstart();
        });

        //this.playstart();

    }

    /**
     * ゲーム開始
     */
    playstart() {

        //console.log("playstart");

        let tmprect = new createjs.Shape();
        tmprect.graphics.beginFill("#fff").drawRect(
            0,
            0,
            this.resources.get_game_window_answer().getBounds().width,
            this.resources.get_game_window_answer().getBounds().height)
        ;
        tmprect.alpha = 0.01;
                
        //console.log( this.resources.QuestionLIst["00"] );
        //console.log( this.QuestionTable[ this.questNum ] );

        // テキストとか
        let thisQuestObj = this.QuestionTable[ this.questNum ];

        if (GameQuizMain.selectGame == GameQuizMain.SELECT_GAMETYPE_ONCE) {
            thisQuestObj = this.QuestionTableO[ this.questNum ];
        } else {
            if (this.questNum % 2) {
                thisQuestObj = this.QuestionTableM[ Math.floor(this.questNum/2) ];
            } else {
                thisQuestObj = this.QuestionTableP[ Math.floor(this.questNum/2) ];
            }
        }

        let tmpObj = thisQuestObj[0];
        let k = tmpObj.match(/\\n/g);
        let n = 0;

        this.questionText.y = this.Window_question.y + 50;
        if (k) {
            n = k.length;
            this.questionText.y = this.Window_question.y + 50 - (n*20);
        }   //console.log(n);

        let r = tmpObj.split("\\n");
        tmpObj = r.join("\n");
        this.questionText.text = tmpObj;
        this.questionText.visible = false;

        this.thisCorrect = -1;
        let tmpt = [
            {text:thisQuestObj[1],correct:this.GAME_SCORE_OK},
            {text:thisQuestObj[2],correct:this.GAME_SCORE_NG},
            {text:thisQuestObj[3],correct:this.GAME_SCORE_NG},
            {text:thisQuestObj[4],correct:this.GAME_SCORE_NG},
        ];
        
        // お答えください.txt
        let tmptxt = new CustomText();
        tmptxt.setFont(50, true);
        tmptxt.lineHeight = 50;
        tmptxt.color = '#000';
        this.QuestionArea.addChild(tmptxt);

        this.answerUser = this.checkuser(this.questNum);
        if (this.answerUser == 2) {
            this.BackGroundBase.visible = false;
            this.BackGroundPapa.visible = false;
            this.BackGroundMama.visible = true;
            
            // 問題画像
            this.Window_quizImage = this.resources.get_game_questionPyaker_mama();
            this.Window_quizImage.x = this.Window_quizImageArea.x+5;
            this.Window_quizImage.y = this.Window_quizImageArea.y+5;
            this.QuestionArea.addChild(this.Window_quizImage);

            //
            tmptxt.x = this.Window_quizImage.x+300;
            tmptxt.y = 150-50;
            tmptxt.text = this.QuestionUser[this.answerUser].text;

        } else if (this.answerUser == 1) {
            this.BackGroundBase.visible = false;
            this.BackGroundPapa.visible = true;
            this.BackGroundMama.visible = false;
            
            // 問題画像
            this.Window_quizImage = this.resources.get_game_questionPyaker_papa();
            this.Window_quizImage.x = this.Window_quizImageArea.x+5;
            this.Window_quizImage.y = this.Window_quizImageArea.y+5;
            this.QuestionArea.addChild(this.Window_quizImage);
            
            //
            tmptxt.x = this.Window_quizImage.x+300;
            tmptxt.y = 150-50;
            tmptxt.text = this.QuestionUser[this.answerUser].text;

        } else {
            this.BackGroundBase.visible = true;
            this.BackGroundPapa.visible = false;
            this.BackGroundMama.visible = false;

            // 問題画像
            this.Window_quizImage = this.resources.get_game_questionPyaker_once();
            this.Window_quizImage.x = this.Window_quizImageArea.x+5;
            this.Window_quizImage.y = this.Window_quizImageArea.y+5;
            this.QuestionArea.addChild(this.Window_quizImage);
            
            //
            tmptxt.x = this.Window_quizImage.x+300;
            tmptxt.y = 150-25;
            tmptxt.text = this.QuestionUser[this.answerUser].text;

        }

        //
        this.questNum++;
        if (this.questNum >= this.questAll) {
            this.questNum = this.questAll;
            this.NavigateTextLeft.text = "最終問題";
        } else {
            this.NavigateTextLeft.text = "第 " + this.questNum + " 問";
        }
        
        this.NavigateTextRight.text = "全12問";

        // シャッフル
        if (!GameQuizMain.isDebug) {
            tmpt = tmpt.map(
                function(a){return {weight:Math.random(), value:a}})
                .sort(function(a, b){return a.weight - b.weight})
                .map(function(a){return a.value}
            );
        }

        this.QuizQuestionWindow = [
            new QuestionObject(),
            new QuestionObject(),
            new QuestionObject(),
            new QuestionObject()
        ]

        // 選択肢作成
        for(let i=0; i<4; i++) {
            //this.QuizQuestionWindow[i] = new QuestionObject();
            this.QuizQuestionWindow[i].rect = new SimpleButton(tmprect,tmprect,tmprect,tmprect);

            this.QuizQuestionWindow[i].x = this.QuestionWindowXY[i].x;
            this.QuizQuestionWindow[i].y = this.QuestionWindowXY[i].y;
            this.QuizQuestionWindow[i].id = (i);
            this.QuizQuestionWindow[i].flag = true;
            this.QuizQuestionWindow[i].Btnset(this);

            this.QuizQuestionWindow[i].image = this.resources.get_game_window_answer();
            this.QuizQuestionWindow[i].image.x = this.QuizQuestionWindow[i].x;
            this.QuizQuestionWindow[i].image.y = this.QuizQuestionWindow[i].y;
            this.QuestionArea.addChild(this.QuizQuestionWindow[i].image);

            this.QuizQuestionWindow[i].rect_right = new createjs.Shape();
            this.QuizQuestionWindow[i].rect_right.graphics.beginFill("#99f").drawRect(0,0,this.resources.get_game_window_answer().getBounds().width,this.resources.get_game_window_answer().getBounds().height);
            this.QuizQuestionWindow[i].rect_right.alpha = 0.75
            this.QuizQuestionWindow[i].rect_right.x = this.QuizQuestionWindow[i].x;
            this.QuizQuestionWindow[i].rect_right.y = this.QuizQuestionWindow[i].y;
            this.QuizQuestionWindow[i].rect_right.visible = false;
            this.QuestionArea.addChild(this.QuizQuestionWindow[i].rect_right);

            this.QuizQuestionWindow[i].rect_worng = new createjs.Shape();
            this.QuizQuestionWindow[i].rect_worng.graphics.beginFill("#f99").drawRect(0,0,this.resources.get_game_window_answer().getBounds().width,this.resources.get_game_window_answer().getBounds().height);
            this.QuizQuestionWindow[i].rect_worng.alpha = 0.75
            this.QuizQuestionWindow[i].rect_worng.x = this.QuizQuestionWindow[i].x;
            this.QuizQuestionWindow[i].rect_worng.y = this.QuizQuestionWindow[i].y;
            this.QuizQuestionWindow[i].rect_worng.visible = false;
            this.QuestionArea.addChild(this.QuizQuestionWindow[i].rect_worng);

            this.QuizQuestionWindow[i].ans_num = this.resources[ this.QuestionWindowXY[i].img ]();
            this.QuizQuestionWindow[i].ans_num.x = this.QuizQuestionWindow[i].x;
            this.QuizQuestionWindow[i].ans_num.y = this.QuizQuestionWindow[i].y;
            this.QuestionArea.addChild(this.QuizQuestionWindow[i].ans_num);

            this.QuizQuestionWindow[i].text = new CustomText;
            this.QuizQuestionWindow[i].text.setFont(48, true);
            this.QuizQuestionWindow[i].text.color = '#000';
            this.QuizQuestionWindow[i].text.setMaxWidth(40*17);

            this.QuizQuestionWindow[i].text.text = tmpt[i].text;
            this.QuizQuestionWindow[i].text.x = this.QuizQuestionWindow[i].x + 90;
            this.QuizQuestionWindow[i].text.y = this.QuizQuestionWindow[i].y + 18;
            this.QuizQuestionWindow[i].text.visible = false;
            this.QuestionArea.addChild(this.QuizQuestionWindow[i].text);

            this.QuizQuestionWindow[i].rect.x = this.QuizQuestionWindow[i].x;
            this.QuizQuestionWindow[i].rect.y = this.QuizQuestionWindow[i].y;
            this.QuizQuestionWindow[i].rect.visible = false;
            this.QuestionArea.addChild(this.QuizQuestionWindow[i].rect);

            // 正解？
            if (tmpt[i].correct == this.GAME_SCORE_OK) {
                this.thisCorrect = i;
            }

        }

        // 〇×
        this.QuiestionRight = this.resources.get_game_quiz_right();
        this.QuiestionRight.x = this.width/2-(315/2);
        //this.QuiestionRight.y = this.height/2-(315/2);
        this.QuiestionRight.y = 600+50;//-(315/2);
        this.QuiestionRight.alpha = 0.8;
        this.QuiestionRight.visible = false;
        this.QuestionArea.addChild(this.QuiestionRight);

        this.QuiestionWrong = this.resources.get_game_quiz_wrong();
        this.QuiestionWrong.x = this.width/2-(315/2);
        //this.QuiestionWrong.y = this.height/2-(315/2);
        this.QuiestionWrong.y = 600+50;//-(315/2);
        this.QuiestionWrong.alpha = 0.8;
        this.QuiestionWrong.visible = false;
        this.QuestionArea.addChild(this.QuiestionWrong);

        // タイマー
        this.timebar.image.scaleX = 1;
        this.timebar.setTimer( this.MaxTime, this.timebar.MINING);
        this.timebar.visible(true);

        // カウント開始
        createjs.Tween.get(this.ResultMask)
        .wait(500)
        .call(() => {
            this.questionText.visible = true;
        })
        .wait(500)
        .call(() => {
            
            for(let i=0; i<4; i++) {
                this.QuizQuestionWindow[i].text.visible = true;
                this.QuizQuestionWindow[i].rect.visible = true;
            }

            this.Sound.playBGM( "SE_QUIZ_TIMER" );

            this.timebar.start(() => {
                this.quizCheck(-1);
            });

        });

        this.Sound.playSE( "SE_QUIZ_OPNE" );
        
        //console.log("playstart");
        GameQuizMain.setBanner( (this.questNum%3) );
    }

    /**
     * ゲーム終了演出
     */
    timeup() {

        this.ResultScoreArea.removeAllChildren();
        
        this.returnButton.visible = false;
        this.retryButton.visible = false;

        this.ResultContainer.visible = true;
        this.ResultScoreArea.visible = true;
        this.ResultMask.alpha = 0.1;
        this.ResultMask.visible = true;
        
        //console.log(this.RsultScore);

        for(let i=0; i<this.questAll; i++) {

            if (this.resultScores[i].score == this.GAME_SCORE_OK) {
                this.resultScores[i].img = this.resources.get_game_result_ball_ok();
            } else {
                this.resultScores[i].img = this.resources.get_game_result_ball_ng();
            }

            this.resultScores[i].img.x = this.resultScores[i].x;
            this.resultScores[i].img.y = this.resultScores[i].y;
            this.resultScores[i].img.visible = false;
            this.ResultScoreArea.addChild(this.resultScores[i].img);
        }

        this.getScore();

        this.ResultText_once.visible = false;
        this.ResultRankText_once.visible = false;

        this.ResultText_family_a.visible = false;
        this.ResultRankText_family_a.visible = false;
        this.ResultText_family_b.visible = false;
        this.ResultRankText_family_b.visible = false;

        this.BackGroundResult.visible = true;

        if ( this.checkuser(this.questNum) == 0) {
            
            this.ResultText_once.text = this.score + "問正解！"

            const textTable = this.ResultRankTable_once;
            this.ResultRankText_once.text = textTable[ (textTable.length-1) ].text;
            for(let i=0; i<textTable.length; i++) {
                if (textTable[i].score <= this.score) {
                    this.ResultRankText_once.text = textTable[i].text;
                    break;
                }
            }

            this.resultscoreeffect_once();
        } else {

            this.ResultText_family_a.text = this.score_papa + "問正解！"

            const textTable_a = this.ResultRankTable_family;
            this.ResultRankText_family_a.text = textTable_a[ (textTable_a.length-1) ].text;
            for(let i=0; i<textTable_a.length; i++) {
                if (textTable_a[i].score <= this.score_papa) {
                    this.ResultRankText_family_a.text = textTable_a[i].text;
                    break;
                }
            }

            this.ResultText_family_b.text = this.score_mama + "問正解！"

            const textTable_b = this.ResultRankTable_family;
            this.ResultRankText_family_b.text = textTable_b[ (textTable_b.length-1) ].text;
            for(let i=0; i<textTable_b.length; i++) {
                if (textTable_b[i].score <= this.score_mama) {
                    this.ResultRankText_family_b.text = textTable_b[i].text;
                    break;
                }
            }

            const image_a = this.resources.get_game_questionPyaker_papa();
            image_a.x = 0;
            image_a.y = this.ResultText_family_a.y-75;
            this.ResultScoreArea.addChild(image_a);

            const image_b = this.resources.get_game_questionPyaker_mama();
            image_b.x = 0;
            image_b.y = this.ResultText_family_b.y-75;
            this.ResultScoreArea.addChild(image_b);

            this.resultscoreeffect_family();
        }

    }

    resultscoreeffect_once() {

        createjs.Tween.get(this.ResultMask)
        .to({ alpha: 0.25 }, 100)
        .wait(500)
        .call(() => {
            this.resultScores[0].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[1].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[2].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[3].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[4].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[5].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[6].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[7].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[8].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[9].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[10].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[11].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(500)
        .call(() => {
            
            this.ResultText_once.visible = true;
            this.ResultRankText_once.visible = true;

            this.retryButton.visible = true;
            this.returnButton.visible = true;
            this.Sound.playSE( "SE_START_DOWN" );
            
        });

    }

    resultscoreeffect_family() {

        createjs.Tween.get(this.ResultMask)
        .to({ alpha: 0.25 }, 100)
        .wait(500)
        .call(() => {
            this.resultScores[0].img.visible = true;
            this.resultScores[1].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[2].img.visible = true;
            this.resultScores[3].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[4].img.visible = true;
            this.resultScores[5].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[6].img.visible = true;
            this.resultScores[7].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[8].img.visible = true;
            this.resultScores[9].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(100)
        .call(() => {
            this.resultScores[10].img.visible = true;
            this.resultScores[11].img.visible = true;
            this.Sound.playSE( "SE_RESULT_COUNT" );
        }).wait(500)
        .call(() => {
            
            this.ResultText_family_a.visible = true;
            this.ResultRankText_family_a.visible = true;
            this.ResultText_family_b.visible = true;
            this.ResultRankText_family_b.visible = true;

            this.retryButton.visible = true;
            this.returnButton.visible = true;
            this.Sound.playSE( "SE_START_DOWN" );
            
        });

    }

    /**
     * 回答
     */
    quizCheck(id) {
        //console.log(id);

        this.timebar.stop();
        this.Sound.stopBGM();

        for(let i=0; i<4; i++) {
            this.QuizQuestionWindow[i].rect.visible = false;
        }

        // debug対策
        let tragetQuiz = (this.questNum-1);
        if (tragetQuiz >= (this.resultScores.length-1) ) tragetQuiz = (this.resultScores.length-1);
        //console.log(tragetQuiz);
        let quizwait = 1000;

        if (id == this.thisCorrect) {
            //this.score++;
            this.resultScores[ tragetQuiz ].score = this.GAME_SCORE_OK;
            this.resultScores[ tragetQuiz ].user = this.answerUser;
            this.QuiestionRight.visible = true;
            this.QuiestionWrong.visible = false;

            this.QuizQuestionWindow[ this.thisCorrect ].rect_right.visible = true;
            //this.QuizQuestionWindow[id].rect_worng.visible = false;

            this.Sound.playSE( "SE_QUIZ_OK" );
            quizwait = 1500;

        } else {
            this.resultScores[ tragetQuiz ].score = this.GAME_SCORE_NG;
            this.resultScores[ tragetQuiz ].user = this.answerUser;
            this.QuiestionRight.visible = false;
            this.QuiestionWrong.visible = true;

            this.QuizQuestionWindow[ this.thisCorrect ].rect_right.visible = true;
            if (id >= 0) this.QuizQuestionWindow[ id ].rect_worng.visible = true;

            this.Sound.playSE( "SE_QUIZ_NG" );
            quizwait = 2500;

        }

        createjs.Tween.get(this.Mask)
        .wait(quizwait)
        .call(() => {

            this.QuestionArea.removeAllChildren();

            if (this.questNum >= this.questAll) {
                //console.log(this.score);
                this.questionText.visible = false;
                setTimeout(()=>{
                    this.GameArea.visible = false;
                    this.timeup();
                }, 1000);

            } else {
                
                this.playstart();
            }    
        });
    }

    // テーブル抽選
    randTabel(array) {

        var tmp = array.reduce(function (sum, element) {
            return sum + element;
        }, 0);

        var max = tmp;
        for (var i = 0; i < array.length; i++) {
            tmp -= array[i];
            if ((Math.random() * max) >= tmp) {
                return i;
            }
        }

        return 0;
    }

    // 加点処理
    setScore(s) {
        this.score += s;
        this.text_score_value.setNumber(this.score);
    }

    getScore(){
        //console.log(this.resultScores);
        this.score = 0;
        this.score_papa = 0;
        this.score_mama = 0;
        for(let i=0; i<this.questAll; i++) { 
            if (this.resultScores[i].score == this.GAME_SCORE_OK) {
                this.score++;

                if (this.resultScores[i].user == this.AnswerUserPapa)  {
                    this.score_papa++;
                } else if (this.resultScores[i].user == this.AnswerUserMama) {
                    this.score_mama++;
                }

                //console.log(this.score,this.score_mama,this.score_papa, this.resultScores[i].user);
            }
        }

        return this.score;
    }

    // ゲームの停止
    stopgGame() {
        this.GamePoseFlag = !this.GamePoseFlag;
        this.CountdownMask.visible = this.GamePoseFlag;
    }

    // 回答者設定
    checkuser(num) {
        if (GameQuizMain.selectGame == GameQuizMain.SELECT_GAMETYPE_ONCE) {
            return 0;
        } else {
            if (num % 2) {
                return this.AnswerUserMama;
            } else {
                return this.AnswerUserPapa;
            }
        }
    }
}

// 回答ボタン
export class QuestionObject {

    x:number;
    y:number;
    id:number;
    image: createjs.Sprite;
    ans_num: createjs.Sprite;
    select: createjs.Sprite;
    rect: SimpleButton;
    rect_right: createjs.Shape;
    rect_worng: createjs.Shape;
    text: CustomText;

    flag:boolean;
    
    Btnset(view) {
        this.rect.setFunc('click', () => {
            if (this.flag) {
                view.quizCheck(this.id);
            }
        });

        //this.flag = true;
    }

    BtnStop() {
        this.flag = false;
    }

}


// タイマー
export class TimeBar {
    
    x:number;
    y:number;
    image: createjs.Sprite;
    bmp:createjs.Bitmap;
    sourceRect:createjs.Rectangle;

    sec:number;
    timerStart:Date;
    timercount:number;
    thisticker:any;    
    stopbar:number;

    rev:number;
    par:number;
    MAXING = -1;// 0から1
    MINING = 1;// 1から0

    CountdownType:number = 0; // カウントダウン 1:あり／0:なし
    CountRedLimit:boolean = false;

    timebarId:number = 15;
    //timebarRedId:number = 3;

    statefunc:any;
    timerWait:number;
    dateWait:Date;

    timingfunc:any;
    timingTimer:number;
    isFinish:boolean;
    
    setTimer(sec:number, type:number){
        this.timercount = 0;
        this.sec = sec;

        if (type == this.MINING) {
            this.image.scaleX = 1;
            this.rev = this.MINING;
        } else {
            this.image.scaleX = 0;
            this.rev = this.MAXING;
        }

        this.image.x = this.x;
        this.image.y = this.y;
        this.image.alpha = 1;

        this.setBmp(this.image.scaleX);

        this.bmp.x = this.image.x+64;
        this.bmp.y = this.image.y+34;
        this.bmp.visible = this.image.visible;
        this.bmp.scaleX = this.image.scaleX;
        this.bmp.alpha = this.image.alpha;

        this.image.visible = true;
        this.bmp.visible = true;

        this.timingTimer = -1;
        this.CountRedLimit = false;
        this.isFinish = false;  // 最終問題時の例外
    }
    
    start(func) {

        this.timerStart = new Date();
        this.timerWait = 0;
        this.dateWait = new Date();
        this.statefunc = func;
        
        //console.log(this.rev, this.bmp.x, this.bmp.y, this.bmp.visible);
        createjs.Ticker.removeEventListener('tick', this.thisticker);
        this.thisticker = createjs.Ticker.addEventListener('tick', () => {
            this.tickerevent();
        });
    }

    tickerevent() {

        // 時間減少
        var cnt = new Date().getTime() - this.timerStart.getTime() - this.timerWait;
        this.timercount += (cnt);
        //console.log(cnt);

        if (this.rev == this.MINING) {
            var par = 1-(cnt/this.sec);
        } else {
            var par = 0+(cnt/this.sec);
        }

        if (par <= 0) par = 0;
        if (par >= 1) par = 1;
        this.bmp.scaleX = par;
        //console.log(par);
        //if (par < 0.5 && this.CountdownType) createjs.Ticker.removeEventListener('tick', this.thisticker);

        // 残り時間
        var res = this.sec - cnt;
        if (res < 0 ) res = 0;

        //console.log(this.timingTimer, res);

        // カウントダウン
        this.setBmp(par);

        // 目標時間到達
        if (cnt > this.sec) {
            this.stop();
            this.statefunc();
        }

        //setTimeout(() => {
        //    func();
         //}, sec);

    }

    stop() {
        createjs.Ticker.removeEventListener('tick', this.thisticker);
    }

    delete() {
        this.stop();
        this.image.visible = false;
        this.bmp.visible = false;
    }

    visible(flag:boolean) {
        //console.log(flag);
        this.image.visible = flag;
        this.bmp.visible = flag;
    }

    // 一時停止
    pauesd () {
        //console.log(this.thisticker.pauesd);
        createjs.Ticker.removeEventListener('tick', this.thisticker);
        this.dateWait = new Date();
    }

    setBmp(par) {
        //this.image.x = (QuizMain.stageWidth/2)-((this.image.getBounds().width*par)/2);
        this.bmp.sourceRect = new createjs.Rectangle(
            this.image.spriteSheet.getFrame(this.timebarId).rect.x,
            this.image.spriteSheet.getFrame(this.timebarId).rect.y,
            this.image.spriteSheet.getFrame(this.timebarId).rect.width, // * par,
            this.image.spriteSheet.getFrame(this.timebarId).rect.height * 1,
        );
        this.bmp.x = this.x+64
        //console.log(par, this.bmp.getBounds().width);
    }

}

export class QuestionWindowXY {
    x:number;
    y:number;
    img:any
}

export class QuestionUser {
    text:string;
    bg:any;
    img:any
}

export class ResultScore {
    score:number;
    x:number;
    y:number;
    img:any;
    user:number;
}